import { mapArray, mapEmployeeFromServer } from "@/shared";

export const mapEmployeesFromServer = mapArray(mapEmployeeFromServer);
